import { render } from "./SrchClassrooms.vue?vue&type=template&id=66ea8bec&scoped=true"
import script from "./SrchClassrooms.vue?vue&type=script&lang=js"
export * from "./SrchClassrooms.vue?vue&type=script&lang=js"

import "./SrchClassrooms.vue?vue&type=style&index=0&id=66ea8bec&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66ea8bec"]])

export default __exports__